import { Box, FormHelperText } from "@mui/material"
import MDEditor, { MDEditorProps, commands } from "@uiw/react-md-editor"
import rehypeSanitize from "rehype-sanitize"

export type MarkdownEditorProps = MDEditorProps & {
  errorMessage?: string
}

export const MarkdownEditor = (props: MarkdownEditorProps) => {
  return (
    <Box>
      <MDEditor
        {...props}
        data-color-mode="light"
        commands={[
          // font related commands
          commands.heading,
          commands.bold,
          commands.italic,
          commands.strikethrough,

          commands.divider,

          // reference related commands
          commands.link,
          commands.quote,
          commands.code,

          commands.divider,

          // list related commands
          commands.unorderedListCommand,
          commands.orderedListCommand,
          commands.checkedListCommand,

          commands.divider,

          commands.help,
        ]}
        style={{ border: props.errorMessage ? "1px solid red" : undefined }}
        previewOptions={{
          rehypePlugins: [[rehypeSanitize]],
        }}
      />
      <FormHelperText error>{props.errorMessage}</FormHelperText>
    </Box>
  )
}
